import { render, staticRenderFns } from "./ReadList.vue?vue&type=template&id=2de78b8e&scoped=true&"
import script from "./ReadList.vue?vue&type=script&lang=ts&"
export * from "./ReadList.vue?vue&type=script&lang=ts&"
import style0 from "./ReadList.vue?vue&type=style&index=0&id=2de78b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de78b8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de78b8e')) {
      api.createRecord('2de78b8e', component.options)
    } else {
      api.reload('2de78b8e', component.options)
    }
    module.hot.accept("./ReadList.vue?vue&type=template&id=2de78b8e&scoped=true&", function () {
      api.rerender('2de78b8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ReadList.vue"
export default component.exports